module.exports = "/static/assets/fd2022f573561d6fcc1102f49fccf615.png";